import { takeEvery, takeLatest } from "redux-saga/effects";
import { fetcherForSagas } from "@/store/fetcherForSagas";
import { loginSuccess, logoutDone } from "@/store/actions";
import {
  fetchPrograms,
  fetchProgramsStart,
  fetchProgramsSuccess,
  fetchProgramsFailure,
  fetchProgram,
  fetchProgramStart,
  fetchProgramSuccess,
  fetchProgramFailure,
} from "@/store/slices/programs";

import { requestProgram, requestPrograms } from "@/common/api/requests";

function* programs() {
  yield takeLatest(
    [logoutDone],
    fetcherForSagas({
      start: fetchProgramsStart,
      success: ({ data, ...other }: any) => fetchProgramsSuccess({ data, ...other }),
      failure: fetchProgramsFailure,
      useToken: false,
      request: () => requestPrograms(),
    })
  );
  yield takeLatest(
    fetchPrograms,
    fetcherForSagas({
      start: fetchProgramsStart,
      success: ({ data, ...other }: any) => fetchProgramsSuccess({ data, ...other }),
      failure: fetchProgramsFailure,
      request: () => requestPrograms(),
    })
  );
  yield takeEvery(
    loginSuccess,
    fetcherForSagas({
      start: fetchProgramsStart,
      success: ({ data, ...other }: any) => fetchProgramsSuccess({ data, ...other }),
      failure: fetchProgramsFailure,
      request: () => requestPrograms(),
    })
  );
  yield takeEvery(
    fetchProgram,
    fetcherForSagas({
      start: fetchProgramStart,
      success: fetchProgramSuccess,
      failure: fetchProgramFailure,
      request: ({ payload }: any) => requestProgram(payload),
    })
  );
}

export default programs;
